import { get, post } from '../services/common/common.service';

import { erpProductEndPoints } from '../constants/endpoint';

export const productSearch = (payload) =>
  post(erpProductEndPoints.searchProduct, payload);

export const productType = () => get(erpProductEndPoints.productType);

export const hardwareClass = (payload) =>
  get(
    `${erpProductEndPoints.hardwareClass}?searchText=${payload.searchText}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );

export const generalInfoTab = (payload) =>
  get(`${erpProductEndPoints.generalInfoTab}?productId=${payload}`);

export const productFamily = (payload) => {
  return get(
    `${erpProductEndPoints.productFamilyBillClass}?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`
  );
};
export const getSalesInfoTabData = (payload) => {
  return get(
    `${erpProductEndPoints.salesInfo}?productId=${payload.productId}&isSupported=${payload.isSupported}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
  );
};

export const serviceModal = (payload) => {
  return get(
    `${erpProductEndPoints.serviceModal}?pageIndex=${payload.pageIndex}&RecordCount=${payload.recordCount}&name=${payload.name}`
  );
};

export const saveGeneralInfo = (payload) => {
  return post(erpProductEndPoints.saveGeneralInfo, payload);
};

export const serviceInfoModel = (payload) => {
  return get(
    `${erpProductEndPoints.serviceInfoModel}?productId=${payload.productId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

export const serviceInfoSubModel = (payload) => {
  return post(erpProductEndPoints.serviceInfoSubModel, payload);
};

export const subModelSearch = (payload) => {
  return get(
    `${erpProductEndPoints.subModelSearch}?name=${payload.name}&RecordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}&modelId=${payload.modelId}`
  );
};

export const fetchServiceFee = (payload) => {
  return get(`${erpProductEndPoints.sericeFee}?productId=${payload}`);
};

export const FetchserviceFeeGridData = (payload) => {
  return get(
    `${erpProductEndPoints.seviceFeeGridData}?priceClassId=${payload.priceClassId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

export const searchContaractData = (payload) => {
  return post(erpProductEndPoints.searchContracts, payload);
};

export const serviceProductDetails = (payload) => {
  return get(
    `${erpProductEndPoints.ServiceProductDetails}?productId=${payload}`
  );
};

export const endOfServiceGridData = (payload) => {
  return get(
    `${erpProductEndPoints.endOfServiceGridData}?productId=${payload.productId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

export const generalInfoSave = (payload) => {
  return post(erpProductEndPoints.generalInfoSave, payload);
};

export const saveModesNSubModels = (payload) => {
  return post(erpProductEndPoints.saveSubModelsNSubModels, payload);
};

export const postServiceInfoFee = (payload) => {
  return post(erpProductEndPoints.saveServiceInfoFee, payload);
};

export const postEndOfService = (payload) => {
  return post(erpProductEndPoints.saveEndOfService, payload);
};

export const serviceInfoModelDateValidate = (payload) => {
  return get(
    `${erpProductEndPoints.serviceInfoModel}?productId=${payload.productId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}&effectiveDate=${payload.effectiveDate}`
  );
};

export const serviceInfoSubModelDateValidate = (payload) => {
  return post(erpProductEndPoints.serviceInfoSubModel, payload);
};

export const eosModelAcceptButton = (payload) => {
  return post(erpProductEndPoints.eosModelAcceptButton, payload);
};

//eos job run api
export const eosJobRun = (payload) => {
  if (payload?.contractId) {
    if (payload?.eosDate) {
      return post(
        `${erpProductEndPoints.eosJob}?productId=${payload.productId}&eosDate=${payload.eosDate}&contractId=${payload.contractId}&userId=${payload.userId}&origComment=${payload.origComment}`
      );
    } else {
      return post(
        `${erpProductEndPoints.eosJob}?productId=${payload.productId}&contractId=${payload.contractId}&userId=${payload.userId}&origComment=${payload.origComment}`
      );
    }
  } else {
    if (payload?.eosDate === null && payload?.prevProdEodDate) {
      return post(
        `${erpProductEndPoints.eosJob}?productId=${payload.productId}&userId=${payload.userId}&origComment=${payload.origComment}&prevProdEodDate=${payload.prevProdEodDate}`
      );
    } else if (payload?.eosDate && payload?.prevProdEodDate) {
      return post(
        `${erpProductEndPoints.eosJob}?productId=${payload.productId}&eosDate=${payload.eosDate}&userId=${payload.userId}&origComment=${payload.origComment}&prevProdEodDate=${payload.prevProdEodDate}`
      );
    } else if (payload?.eosDate && payload?.prevProdEodDate === null) {
      return post(
        `${erpProductEndPoints.eosJob}?productId=${payload.productId}&eosDate=${payload.eosDate}&userId=${payload.userId}&origComment=${payload.origComment}`
      );
    }
  }
};
